const diasSemana = ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"]
const diasSemanaLong = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"]
const diasSemanaLongHtml = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"]
export const HOY = new Date()

export const arrayOfDates = () => {
  const aodates = [HOY]
  for (let index = 0; index < 6; index++) {
    const date = new Date(aodates[index])
    date.setDate(date.getDate() + 1)
    aodates.push(date)
  }
  return aodates
}

export const arrayOfStringDates = () => {
  return arrayOfDates().map((d) => {
    const isoDate = toLocalISOString(d)
    return { fecha: isoDate, diaSemana: getDayLettersLong(isoDate) }
  })
}

function toLocalISOString(date) {
  const offset = date.getTimezoneOffset()
  date = new Date(date.getTime() - offset * 60 * 1000)
  return date.toISOString().substring(0, 10)
}

export function getDayLetters(date) {
  const d = new Date(date)
  return diasSemana[d.getDay()]
}

export function getDayLettersLong(date) {
  const d = new Date(date)
  return diasSemanaLong[d.getDay()]
}

export function getDayLettersLongHtml(date) {
  const d = new Date(date)
  return diasSemanaLongHtml[d.getDay()]
}

export function getDay(date) {
  const year = parseInt(date.substr(0, 4))
  const month = parseInt(date.substr(5, 7)) - 1
  const day = parseInt(date.substr(8, 10))
  const d = new Date(year, month, day, 0, 0, 0, 0)

  return d.getDate()
}

// get 09:32:00 returns 09:32
export function trimHora(hora) {
  return hora.substr(0, 5)
}

// get 04-08-22 returns 04/08
export function formatFecha(fecha) {
  return fecha.replace("-", "/").substr(0, 5)
}

// get 2022-08-04 returns
export function formatFechaDesk(fecha) {
  return `${getDayLettersLongHtml(fecha)} ${getDay(fecha)}`
}

// get 04-08-22 returns a date 2022-08-04
export function createDate(fecha) {
  if (fecha) {
    const fechaString = `20${fecha.substr(6, 2)}-${fecha.substr(3, 2)}-${fecha.substr(0, 2)}`
    // return new Date(fechaString)
    return fechaString
  }
}

export function canCancel(fecha_clase, horario_clase, pase_cancel_limit) {
  let result = true
  if (pase_cancel_limit > 0) {
    const now = new Date().getTime() / 1000 // TODO: ojo acá que uso new date.. y no sé que hace con el GMT
    const year = parseInt(fecha_clase.substr(0, 4))
    const month = parseInt(fecha_clase.substr(5, 7)) - 1
    const day = parseInt(fecha_clase.substr(8, 10))
    const hours = parseInt(horario_clase.substr(0, 2))
    const minutes = parseInt(horario_clase.substr(3, 5))
    const date_clase = new Date(year, month, day, hours, minutes, 0, 0)
    const dt_clase = date_clase.getTime() / 1000
    if (now + pase_cancel_limit > dt_clase) {
      result = false
    }
  }
  return result
}

// ex: dia YYYY-MM-DD | horario HH:mm | offset in seconds
export function horarioMenor(dia, horario, offset = 0) {
  // TODO: acá tal vez también quieran agregar algún límite extra, 2 horas antes no sé
  const offsetTS = offset * 1000

  const dateNow = new Date()
  const timeNow = dateNow.getTime()
  const dateH = new Date(`${dia} ${horario}`)
  const timeH = dateH.getTime()

  if (timeH < timeNow + offsetTS) {
    return true
  }
  return false
}
